"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkedinGetCurrentMemberProfile = exports.linkedinGetCurrentMemberProfileResultSchema = exports.linkedinGetCurrentMemberProfileArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.linkedinGetCurrentMemberProfileArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('get-current-member-profile', zod_1.z.object({}));
var linkedinMemberProfileSchema = zod_1.z.object({
    id: zod_1.z.string().describe('The id of the member'),
    vanityName: zod_1.z.string().describe('The vanity name of the member'),
    profilePicture: zod_1.z.object({
        displayImage: zod_1.z.string().describe('The urn of the profile picture'),
    }),
    localizedFirstName: zod_1.z.string().describe('The first name of the member'),
    localizedLastName: zod_1.z.string().describe('The last name of the member'),
    localizedHeadline: zod_1.z.string().describe('The headline of the member'),
    localizedLocation: zod_1.z.string().describe('The location of the member'),
});
exports.linkedinGetCurrentMemberProfileResultSchema = (0, common_1.PipedreamNodeResultSchema)(linkedinMemberProfileSchema);
exports.linkedinGetCurrentMemberProfile = (0, common_1.createToolMetadata)({
    id: 'linkedinGetCurrentMemberProfile',
    displayName: 'LinkedIn Get Current Member Profile',
    displayDescription: 'Get the profile of the current authenticated LinkedIn member',
    category: 'social',
    color: common_1.BRAND_COLORS.LINKEDIN,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.LINKEDIN),
    icon: 'linkedin',
    argsSchema: exports.linkedinGetCurrentMemberProfileArgsSchema,
}, exports.linkedinGetCurrentMemberProfileResultSchema);
